/** @format */

import { makeStyles, withStyles } from '@material-ui/core';
import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSmallTextButton from '../../../components/Buttons/CustomSmallTextButton';
import InputFormRest from '../../../components/Form/InputFormRest';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { configDefault } from '../../../core/config';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import { tariffConstants } from '../../../modules/tariffs/actions';
import { history } from '../../../core/history';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import i18n from '../../../core/i18n';
import I18n from '../../../components/Translate/I18n';
import SimpleSelectRest from '../../../components/Adescom/SimpleSelectRest';
import SelectFromRest from '../../../components/Form/SelectFromRest';

interface TariffAddProps {
    classes: any;
    editMode?: boolean;
    //TODO Add interface for tariff
    tariff?: any;
}

const TariffAdd = (props: TariffAddProps): React.ReactElement => {
    const dispatch = useDispatch();
    const { classes } = props;
    const URI = '/tariffs';
    const EDIT_MODE = props.editMode ? props.editMode : false;

    const [entityStatus, setEntityStatus] = useState<any>({
        tariffName: null,
        prepaid: null,
        operatorsTariff: null,
        inout: null,
    });
    const [entity, setEntity] = useState<any>(
        props.tariff
            ? {
                  tariffName: props.tariff.tariffName,
                  prepaid: props.tariff.prepaid,
                  operatorsTariff: props.tariff.operatorsTariff,
                  inout: props.tariff.inout,
                  pricelistSchemaId: props.tariff.pricelistSchemaId,
                  type: props.tariff.type,
              }
            : {
                  tariffName: '',
                  prepaid: false,
                  operatorsTariff: false,
                  inout: false,
                  pricelistSchemaId: null,
                  type: null,
              }
    );

    const changeInput = (e: any, stateName: string, type: string, require: boolean, maxValue: number, minValue: number): void => {
        // TODO: Add validation (use entityStatus)
        setEntity({ ...entity, [stateName]: e.target.value });
    };

    const changeCheckbox = (checked: boolean, stateName: string): void => {
        // TODO: Add validation (use entityStatus)
        setEntity({ ...entity, [stateName]: checked });
    };
    const changeSelect = (e: any, stateName: string, require: boolean): void => {
        // TODO: Add validation (use entityStatus)
        setEntity({ ...entity, [stateName]: e.target.value });
    };

    const redirectToTariffList = (): void => history.push(FormGeneralHelper.getRouteUrl('/tariff-list'));

    const saveTariff = (): void => {
        const itemLoaders = new ItemLoaders(dispatch);
        if (props.tariff) {
            itemLoaders.putWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`${URI}/${props.tariff.id}`, configDefault.PLATFORM_API_PREFIX)),
                tariffConstants.EDIT,
                entity,
                () => {
                    redirectToTariffList();
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: true,
                }
            );
        } else {
            itemLoaders.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(URI, configDefault.PLATFORM_API_PREFIX)),
                tariffConstants.ADD,
                entity,
                () => {
                    redirectToTariffList();
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: true,
                }
            );
        }
    };

    return (
        <GridContainer>
            <Card>
                {!props.editMode ? <CardHeader trans="tariffs:t.tariff_add" /> : null}
                <CardBody>
                    <GridItem xs={12} md={6} lg={6}>
                        <GridContainer spacing={2}>
                            <GridItem xs={12} md={12} lg={12}>
                                <InputFormRest
                                    classes={classes}
                                    callback={changeInput}
                                    stateName="tariffName"
                                    stateObjectState={entityStatus.tariffName}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName="tariffs:t.tariff_name"
                                    required={false}
                                    vMax={255}
                                    vMin={0}
                                    value={entity.tariffName}
                                />
                            </GridItem>
                            <GridItem xs={12} md={12} lg={12}>
                                <SelectFromRest
                                    label={'tariffs:type.type'}
                                    required={true}
                                    selectedValue={entity.type}
                                    stateObjectState={entity.type}
                                    restElements={{
                                        'hydra:member': [
                                            { id: 1, mainname: 'tariffs:type.type_1' },
                                            { id: 2, mainname: 'tariffs:type.type_2' },
                                        ],
                                    }}
                                    callback={changeSelect}
                                    stateName={'type'}
                                    propKey="id"
                                    propValue="mainname"
                                    addEmpty={false}
                                    displayEmpty={false}
                                />
                            </GridItem>
                            <GridItem xs={12} md={12} lg={12}>
                                {UserRoleHelper.checkRole(props.tariff ? roles.ROLE_PLATFORM_TARIFF_PUT : roles.ROLE_PLATFORM_TARIFF_POST) && (
                                    <CustomSmallTextButton label={'general:common.save'} callback={saveTariff} callbackParam={{}} />
                                )}
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </CardBody>
            </Card>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(TariffAdd);
